import { NewComponent } from './new.component';
import { DetailComponent } from './detail/detail.component';
import { HomeComponent } from './home/home.component';
import { RequestComponent } from './request/request.component';

export {
  NewComponent as LicenseNewComponent,
  DetailComponent as LicenseNewDetailComponent,
  HomeComponent as LicenseNewHomeComponent,
  RequestComponent as LicenseNewRequestComponent,
};
